import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { encryptData } from "../../UI/crypto";
import config from "../../config";
import { decryptURL } from "../../UI/URLencryption";
function Sidebar12() {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const contentRef1 = useRef(null);
  const contentRef2 = useRef(null);
  const [loading, setLoading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  const toggleDropdown2 = () => {
    setIsOpen2(!isOpen2);
  };

  useEffect(() => {
    if (contentRef1.current) {
      contentRef1.current.style.maxHeight = isOpen1
        ? `${contentRef1.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen1]);

  useEffect(() => {
    if (contentRef2.current) {
      contentRef2.current.style.maxHeight = isOpen2
        ? `${contentRef2.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen2]);

  const isAddSchoolActive = [
    "/class-xii-add-qualifying-jac",
    "/class-xii-add-improvement-jac",
    "/class-xii-add-ex-regular-jac",
    "/class-xii-add-regular-jac",
    "/class-xii-upload-document",
    "/class-xii-add-ex-regular-info-jac",
    "/class-xii-add-improvement-info",
    "/class-xii-add-qualifying-info",
    "/class-xii-regular-student-info",
  ].includes(location.pathname);

  const isReportsActive = [
    "/class-xii-consolidated-checklist",
    "/class-xii-challan-status",
    "/class-xii-generate-challan",
    "/class-xii-checklist-generated",
    "/class-xii-total-registration",
  ].includes(location.pathname);

  // const downloadadmit = (stream) => {
  //   const schoolID = sessionStorage.getItem("schoolCode");
  //   const districtid = sessionStorage.getItem("district");
  //   if (!schoolID) {
  //     alert("School ID is missing.");
  //     return;
  //   }

  //   const domain = window.location.origin;
  //   console.log(domain);
  //   const filePath = `${domain}/Admit_cards/${districtid}/${schoolID}/${stream}.pdf`;
  //   console.log(filePath);
  //   const link = document.createElement("a");
  //   link.href = filePath;
  //   link.download = `${stream}-admit-card-${schoolID}.pdf`;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  const downloadadmit = async (stream) => {
    try {
      let linkKey = "";
      let fileNameStream = "";

      switch (stream) {
        case "ARTS":
          linkKey = "class12admitcardlinkarts";
          fileNameStream = "Arts";
          break;
        case "COMMERCE":
          linkKey = "class12admitcardlinkcommerce";
          fileNameStream = "Commerce";
          break;
        case "SCIENCE":
          linkKey = "class12admitcardlinkscience";
          fileNameStream = "Science";
          break;
        default:
          alert("Invalid stream");
          return;
      }

      const encryptedUrl = sessionStorage.getItem(linkKey);
      const districtCode = sessionStorage.getItem("district");

      if (!encryptedUrl) {
        alert(`No admit card found for ${fileNameStream}`);
        return;
      }

      const finalUrl = decryptURL(encryptedUrl);

      setLoading(true);
      setDownloadProgress(0);

      const response = await fetch(finalUrl);

      if (!response.ok) {
        throw new Error("Failed to download PDF");
      }

      const contentLength = response.headers.get("content-length");
      const total = contentLength ? parseInt(contentLength, 10) : 0;

      const reader = response.body.getReader();
      let receivedLength = 0;
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        receivedLength += value.length;

        if (total) {
          const percent = Math.round((receivedLength / total) * 100);
          setDownloadProgress(percent);
        }
      }

      const blob = new Blob(chunks, { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Admit_Card_Class_XII_${fileNameStream}_${districtCode}.pdf`;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      setLoading(false);
      setDownloadProgress(0);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download admit card");
      setLoading(false);
      setDownloadProgress(0);
    }
  };

  const downloadtr = () => {
    const domain = window.location.origin;
    const classFolder = "class-xii";
    const districtId = sessionStorage.getItem("district");
    const schoolId = sessionStorage.getItem("schoolCode");

    if (!schoolId) {
      alert("School ID is missing.");
      return;
    }
    if (!districtId) {
      alert("District ID is missing.");
      return;
    }
    const filePath = `${domain}/${classFolder}/${districtId}/${schoolId}.pdf`;
    const link = document.createElement("a");
    link.href = filePath;
    link.download = `Tabulation-Register-${schoolId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const movetonextd = (e) => {
    e.preventDefault();

    const params = {
      schooL_CODE: sessionStorage.getItem("schoolCode"),
      schooL_NAME: sessionStorage.getItem("schoolname"),
      heaD_MOBILE_NO: sessionStorage.getItem("headMobileNo"),
      emaiL_ADDRESS: sessionStorage.getItem("schoolEmailId"),
      district: sessionStorage.getItem("district"),
      district_name: sessionStorage.getItem("districtname"),
      assistant_master_no: sessionStorage.getItem("assistantteachercontact"),
    };

    // console.log("Before Encrypt:", params);

    const encryptedData = encryptData(params, config.SECRET_KEY);
    const encodedData = encodeURIComponent(encryptedData);
    window.open(`${config.IA_LINK}/class-xii?data=${encodedData}`, "_blank");
  };
  const lateralstatus = sessionStorage.getItem("Class12LateralStatus");
  return (
    <>
      {loading && (
        <div className="download-modal-overlay">
          <div className="download-modal">
            <div className="spinner"></div>

            <h4>Downloading Admit Card</h4>

            <div className="progress-wrapper">
              <div
                className="progress-bar"
                style={{ width: `${downloadProgress}%` }}
              ></div>
            </div>

            <p>{downloadProgress}% completed</p>
          </div>
        </div>
      )}

      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          <li
            className={`nav-item ${
              location.pathname === "/class-xii-dashboard" ? "active" : ""
            }`}
          >
            <a
              href="#"
              className="nav-link back-g"
              onClick={() => navigate("/class-xii-dashboard")}
            >
              <i className="icon-grid menu-icon"></i>
              <span className="menu-title">Dashboard</span>
            </a>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/class-xii-school-profile" ? "active" : ""
            }`}
          >
            <a
              href="#"
              className="nav-link back-g"
              onClick={() => navigate("/class-xii-school-profile")}
            >
              <i className="fa fa-university menu-icon"></i>
              <span className="menu-title">Profile</span>
            </a>
          </li>
          {/* First Dropdown */}
          <li className={`nav-item ${isAddSchoolActive ? "active" : ""}`}>
            <a
              className="nav-link back-g"
              onClick={toggleDropdown1}
              style={{ cursor: "pointer" }}
              aria-expanded={isOpen1}
              aria-controls="auth1"
            >
              <i className="icon-head menu-icon"></i>
              <span className="menu-title">Add Student</span>
              <i className="menu-arrow"></i>
            </a>
            <div id="auth1" ref={contentRef1} className="custom-collapse">
              <ul className="nav flex-column sub-menu sub-green">
                <li className="nav-item">
                  <a
                    className="nav-link back-g"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-xii-add-regular-jac");
                    }}
                  >
                    Class XII Regular
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link back-g"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-xii-add-ex-regular-jac");
                    }}
                    rel="noopener noreferrer"
                  >
                    Ex-Regular
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link back-g"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-xii-add-improvement-jac");
                    }}
                    rel="noopener noreferrer"
                  >
                    Improvement
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link back-g"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-xii-add-qualifying-jac");
                    }}
                    rel="noopener noreferrer"
                  >
                    Qualifying Exam
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li className={`nav-item ${isReportsActive ? "active" : ""}`}>
            <a
              className="nav-link back-g"
              onClick={toggleDropdown2}
              style={{ cursor: "pointer" }}
              aria-expanded={isOpen2}
              aria-controls="auth2"
            >
              <i className="icon-head menu-icon"></i>
              <span className="menu-title">Reports</span>
              <i className="menu-arrow"></i>
            </a>
            <div id="auth2" ref={contentRef2} className="custom-collapse">
              <ul className="nav flex-column sub-menu sub-green">
                <li className="nav-item">
                  <a
                    className="nav-link back-g"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-xii-total-registration");
                    }}
                  >
                    Total Registration
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link back-g"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-xii-checklist-generated");
                    }}
                    rel="noopener noreferrer"
                  >
                    Checklist Generated
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link back-g"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-xii-generate-challan");
                    }}
                    rel="noopener noreferrer"
                  >
                    Generate Challan
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link back-g"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-xii-challan-status");
                    }}
                    rel="noopener noreferrer"
                  >
                    Challan Status
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link back-g"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-xii-consolidated-checklist");
                    }}
                    rel="noopener noreferrer"
                  >
                    List of Examinees
                  </a>
                </li>
              </ul>
            </div>
          </li>
          {sessionStorage.getItem("correctionstatus12") === "ON" && (
            <li className="nav-item">
              <a
                className="nav-link back-g"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-xii-correct-student");
                }}
              >
                <i class="fa fa-check menu-icon"></i>
                <span className="menu-title ">Correct Student Data</span>
              </a>
            </li>
          )}
          {/* {sessionStorage.getItem("class12profile") === "YES" && ( */}
          <li
            className={`nav-item ${
              location.pathname === "/class-xii-data-not-found" ? "active" : ""
            }`}
          >
            <a
              className="nav-link text-danger back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/class-xii-data-not-found");
              }}
            >
              <i class="fa fa-times menu-icon text-danger"></i>
              <span className="menu-title ">Data Not Found</span>
            </a>
          </li>
          {/* )} */}
          {/* {sessionStorage.getItem("class12profile") === "YES" && ( */}
          <li
            className={`nav-item ${
              location.pathname === "/class-xii-data-not-found-list"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link text-danger back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/class-xii-data-not-found-list");
              }}
            >
              <i class="fa fa-list menu-icon text-danger"></i>
              <span className="menu-title " style={{ fontSize: "13px" }}>
                Status of Data Not Found
              </span>
            </a>
          </li>
          {/* )} */}
          {
          // sessionStorage.getItem("class12admitcardbutton") === "ON" &&
            sessionStorage.getItem("class12admitcardlinkarts") && (
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit("ARTS");
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">Admit Card (Arts)</span>
                </a>
              </li>
            )}
          {
          // sessionStorage.getItem("class12admitcardbutton") === "ON" &&
            sessionStorage.getItem("class12admitcardlinkcommerce") && (
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit("COMMERCE");
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">Admit Card (Commerce)</span>
                </a>
              </li>
            )}
          {
          // sessionStorage.getItem("class12admitcardbutton") === "ON" &&
            sessionStorage.getItem("class12admitcardlinkscience") && (
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit("SCIENCE");
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">Admit Card (Science)</span>
                </a>
              </li>
            )}
          {sessionStorage.getItem("tabulationReg") === "ON" && (
            <li className="nav-item blink-text" style={{ padding: "1px 6px" }}>
              <a
                className="nav-link  back-g color btn btn-danger text-white"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  downloadtr();
                }}
                style={{
                  backgroundColor: "#dc3545",
                  padding: "8px 12px",
                  borderRadius: "3px",
                }}
              >
                <i className="fa fa-download menu-icon text-white"></i>
                <span className="menu-title" style={{ fontSize: "12px" }}>
                  TABULATION REGISTER
                </span>
              </a>
            </li>
          )}
         {sessionStorage.getItem("class12IAportal") === "ON" && ( 
            <li className="nav-item ">
              <a
                className="nav-link  back-g nav-link-ia12 text-success"
                href="#"
                onClick={movetonextd}
              >
                <i className="fa fa-arrow-right menu-icon text-success"></i>
                <span
                  className="menu-title text-success"
                  style={{ fontSize: "13px", fontWeight: "600" }}
                >
                IA/Practical Marks<br/> Entry Portal
                </span>
              </a>
            </li>
       )} 
          {lateralstatus && lateralstatus === "ON" && (
            <li
              className={`nav-item ${
                location.pathname === "/class-xii-backdoor-generate-challan"
                  ? "active"
                  : ""
              }`}
            >
              <a
                style={{ cursor: "pointer" }}
                className="nav-link back-g"
                onClick={() => navigate("/class-xii-backdoor-generate-challan")}
              >
                <i class="fa fa-list menu-icon"></i>
                <span className="menu-title">Lateral Generate Challan</span>
              </a>
            </li>
          )}
        </ul>
      </nav>
    </>
  );
}

export default Sidebar12;
